module.exports = __webpack_public_path__ + "img/question_04_icon.69d2692f.png";